export const normalizer = (order, accessTokenPayload) => {
  order.sourceIntegrationId = order.sourceIntegration?.id;
  order.ownerId = order.ownerId || accessTokenPayload.owner;
  order.deliveryId = order.delivery?.id;
  order.billingId = order.billing?.id;
  order.warehouseId = order.warehouse?.id;
  order.totalWeight = order.totalWeight || null;
  order.insuranceValue = order.insuranceValue || null;
  order.goodsValue = order.goodsValue || null;
  order.cashOnDeliveryValue = order.cashOnDeliveryValue || null;
  order.cashOnDeliveryCollectionMethodCode = order.cashOnDeliveryValue
    ? order.cashOnDeliveryCollectionMethodCode?.code ||
      order.cashOnDeliveryCollectionMethodCode ||
      "CASH"
    : null;
  order.currency = order.currency?.value || order.currency;
  if (order.sourceIntegrationId) {
    order.sourceType = "STORE";
  }
  order.orderDetails = order.orderDetails?.length;
  return order;
};

export const recalculateOrderValues = (
  currentOrder = {},
  orderDetails = [],
  settings = { cashOnDelivery: false, insuranceValue: false }
) => {
  const totalPrice = calcTotalPrice(orderDetails);
  const totalPriceOfShippableArticles =
    calcTotalPriceOfShippableArticles(orderDetails);

  currentOrder.totalWeight = calcTotalWeight(orderDetails);
  currentOrder.totalPrice = totalPrice;
  if (orderDetails.length > 0) {
    const totalPriceVatIncluded = calcTotalPriceVatIncluded(orderDetails);
    currentOrder.totalPriceVatIncluded = totalPriceVatIncluded;
  }

  currentOrder.goodsValue = totalPriceOfShippableArticles;
  if (settings.insuranceValue) {
    currentOrder.insuranceValue = totalPriceOfShippableArticles;
  }
  if (settings.cashOnDelivery) {
    currentOrder.cashOnDeliveryValue = calcCashOnDeliveryValueVatIncluded(
      currentOrder.shippingCost,
      orderDetails
    );
  }

  return currentOrder;
};

export const calcTotalWeight = (orderDetails = []) =>
  orderDetails.reduce((total, item) => total + (item.totalWeight || 0), 0) ||
  null;

export const calcTotalPrice = (orderDetails = []) => {
  return orderDetails.reduce(
    (total, item) => total + (item.totalPrice || 0),
    0
  );
};

export const calcTotalPriceVatIncluded = (orderDetails = []) => {
  const totalPrice = calcTotalPrice(orderDetails);
  const totalPriceVatIncluded =
    totalPrice +
    (orderDetails.reduce(
      (t, { unitPrice = 0, vat = 22, discount = 0, quantity = 1 }) =>
        t + ((unitPrice - discount) * quantity * vat) / 100,
      0
    ) || 0);
  return totalPriceVatIncluded;
};

export const calcTotalPriceOfShippableArticles = (orderDetails = []) =>
  orderDetails.reduce(
    (total, item) =>
      total +
      (item.articleShippingRequired && item.totalPrice > 0
        ? item.totalPrice
        : 0),
    0
  ) || null;

export const calcCashOnDeliveryValueVatIncluded = (
  shippingCost,
  orderDetails = []
) => {
  const cashOnDeliveryValueVatIncluded =
    calcTotalPriceVatIncluded(orderDetails) +
    (shippingCost ? parseFloat(shippingCost) * 1.22 : 0);
  return cashOnDeliveryValueVatIncluded >= 0
    ? cashOnDeliveryValueVatIncluded
    : null;
};

export const getGenericField = (orderGenericFields, genericFields) => {
  let isCashOnDeliveryEnabled = false;
  let isInsuranceEnabled = false;

  if (Array.isArray(orderGenericFields) && Array.isArray(genericFields)) {
    const genericFieldsParsed = genericFields.map((gf) => {
      return { ...gf, jsonStructure: JSON.parse(gf.jsonStructure) };
    });
    const genericField = orderGenericFields.find((ogf) =>
      genericFieldsParsed.some((gf) => gf.rank === ogf.rank)
    );

    if (genericField) {
      const matchingField = genericFieldsParsed.find(
        (gf) => gf.rank === genericField.rank
      );
      //Se necessario controllare la tipologia di input per ricavare isCashOnDeliveryEnabled
      if (matchingField?.jsonStructure?.options) {
        isCashOnDeliveryEnabled = matchingField.jsonStructure.options.some(
          (o) => o.value === genericField.value && o.cashOnDelivery
        );
        isInsuranceEnabled = matchingField.jsonStructure.options.some(
          (o) => o.value === genericField.value && o.insurance
        );
      }
    }
    return { data: genericField, isCashOnDeliveryEnabled, isInsuranceEnabled };
  }
  return { isCashOnDeliveryEnabled, isInsuranceEnabled };
};
